import { useLang } from '../../context/LangContext'

export default function LangToggle({ className = '' }) {
  const { lang, setLang } = useLang()

  return (
    <div className={`lang-toggle ${className}`}>
      <button
        className={`lang-toggle__btn ${lang === 'en' ? 'lang-toggle__btn--active' : ''}`}
        onClick={() => setLang('en')}
      >
        EN
      </button>
      <button
        className={`lang-toggle__btn ${lang === 'bm' ? 'lang-toggle__btn--active' : ''}`}
        onClick={() => setLang('bm')}
      >
        BM
      </button>
    </div>
  )
}
